// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  CONTENT_APPS: '/content/apps',
  CONTENT_APPS_V_HISTORY: '/content/apps-version-history',
  APPS_MANAGE_CATEGORY: '/content/apps/:id/manage-categories',
  USERS: '/users',
  APP_SESSIONS: '/app-sessions',
  REPORTS_MONTHLY: '/reports/monthly',
  ADMIN_USERS: '/settings/access',
  LOGOUT: '/logout',
};

export default ROUTE_PATH;
